// frontend/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import AppProviders from './contexts/AppProviders';

// 🔥 Log environment BEFORE rendering
// console.log("📱 Loaded ENV: REACT_APP_RUOTHSTORE_API =", process.env.REACT_APP_RUOTHSTORE_API);
// console.log("📱 Loaded ENV: REACT_APP_API_BASE_URL =", process.env.REACT_APP_API_BASE_URL);
// console.log("📱 Loaded ENV: REACT_APP_RECIPE_TOOL_URL =", process.env.REACT_APP_RECIPE_TOOL_URL);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </React.StrictMode>
);